// cspell:ignore fevr aout
/**
 * French writes the first of the month as an ordinal: "1er novembre", never
 * "1 novembre". `Intl.DateTimeFormat('fr-CA', { dateStyle: 'long' })` gives the
 * cardinal, so every French date a person reads — on a page or in an email —
 * goes through this. Every other day is cardinal and left as it is.
 *
 * Matches a standalone "1" followed by a month name, so "11 novembre",
 * "21 novembre" and times like "1 h" are untouched.
 */
const FR_MONTHS = 'janv|févr|fevr|mars|avr|mai|juin|juil|août|aout|sept|oct|nov|déc|dec';

const FIRST_OF_MONTH = new RegExp(`(^|[^\\d])1(\\s|\\u00a0|\\u202f)(${FR_MONTHS})`, 'gi');

/**
 * A zero-padded French hour: `fr-CA` with `hour: '2-digit'` (or
 * `timeStyle: 'short'`) gives "08 h 00"; French writes "8 h 00".
 */
const PADDED_HOUR = /(^|[^\d])0(\d)(\s|\u00a0|\u202f)h(\s|\u00a0|\u202f|$)/g;

/**
 * French date and time typography for a formatted string: "1er" for the first
 * of the month, and an unpadded hour ("8 h 00"). A no-op on anything else, so
 * English output can pass through it unchanged.
 */
export function frenchFirstOfMonth(formatted: string): string {
  return formatted.replace(FIRST_OF_MONTH, '$11er$2$3').replace(PADDED_HOUR, '$1$2$3h$4');
}

/**
 * `Intl` long date, with the French ordinal applied. `options` defaults to
 * `{ dateStyle: 'long' }`.
 */
export function formatLocalizedDate(
  date: Date,
  locale: string,
  options: Intl.DateTimeFormatOptions = { dateStyle: 'long' },
): string {
  const formatted = new Intl.DateTimeFormat(locale, options).format(date);
  return locale.toLowerCase().startsWith('fr') ? frenchFirstOfMonth(formatted) : formatted;
}
